import React from 'react'
import styles from './FeaturesExtra.module.scss'
import { IconType } from 'react-icons';

interface Feature {
  id: string;
  text: string;
  icon: IconType;
  future?: boolean;
}

type Props = {
  features: Feature[]
} 

// Исправление 1: React.FC<Props> — дженерик указывается в угловых скобках
export const FeaturesExtra: React.FC<Props> = ({ features }) => {
  return (
    <div className={styles.grid}>
      {features.map(({ id, text, icon: Icon, future }) => (
        <div key={id} className={`${styles.card} ${future ? styles.future : ''}`}>
          <Icon size={20} />
          <span>{text}</span>
          {future && <span className={styles.badge}>скоро</span>}
        </div>
      ))}
    </div>
  )
}